import React, { Fragment } from 'react'
import { Breadcrumb, Card, Icon, Row, Tabs } from 'antd'
import style from './style.css'
import List from './List'
import useTitle from '../../../elements/Hooks/useTitle'

function Invoices(props) {
  useTitle('Invoices')
  return (
    <Fragment>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item>Invoices</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className={style.title}>
            <Icon type="file-protect" style={{ marginRight: 10, color: '#c9121a' }} />
            Sales Invoices
          </h1>
          <p className={style.paragraph}>View and list client invoices.</p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Invoices" key="Invoices">
            <List {...props} type={'Invoices'} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Funds Request" key="RequestFunds">
            <List {...props} type={'RequestFunds'} />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </Fragment>
  )
}

Invoices.propTypes = {}
Invoices.defaultProps = {}

export default Invoices
